"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _breadContainer;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  crumb: {
    height: '25px',
    border: '1px solid #2c9dc5',
    color: '#2c9dc5',
    borderRadius: '25px',
    padding: '0 7px',
    fontWeight: '400',
    cursor: 'pointer',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    MsUserSelect: 'none',
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 10px'
  },
  crumbBox: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '10px'
  },
  breadContainer: (_breadContainer = {
    minWidth: '65%',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontWeight: '300',
    fontSize: '1.1rem',
    backgroundImage: 'rgba(182, 211, 223, 0.4) /* fallback for old browsers */'
  }, _defineProperty(_breadContainer, "backgroundImage", '-webkit-radial-gradient(farthest-side at 50% 30%,rgba(182, 211, 223, 0.4) 70%, rgba(255,255,255,0.01))'), _defineProperty(_breadContainer, "backgroundImage", 'radial-gradient(farthest-side at 50% 30%,rgba(182, 211, 223, 0.4) 70%, rgba(255,255,255,0.01))'), _defineProperty(_breadContainer, "color", '#2c9dc5'), _defineProperty(_breadContainer, "padding", '5px 0'), _defineProperty(_breadContainer, '@media (max-width: 767px)', {
    padding: '5px 30px'
  }), _breadContainer),
  breadRow: {
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '300',
    fontSize: '1.1rem',
    color: '#2c9dc5',
    '@media (max-width: 767px)': {
      display: 'flex',
      flexFlow: 'row wrap',
      height: 'unset'
    }
  },
  crumbSpan: {
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    width: '100%',
    alignItems: 'center'
  },
  hoverCrumb: {
    color: 'white',
    backgroundColor: '#189FE5',
    cursor: 'pointer',
    WebkitBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
    MozBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
    boxShadow: '5px 40px -10px rgba(0,0,0,0.57)',
    transition: 'all 0.7s ease'
  }
};
exports.default = _default;

//# sourceMappingURL=Crumbs.css.js.map